/** Case-insensitive identity for CRM labels (matches Leads / filter semantics). */
export function normalizeLabelKey(value: string): string {
  return String(value || '').trim().toUpperCase();
}

/**
 * Collapse label strings that differ only by casing into one canonical display string.
 * First occurrence in `candidatesInOrder` wins (same as Leads `allLabels` merge).
 */
export function mergeLabelCatalogCandidates(candidatesInOrder: string[]): string[] {
  const labelsByKey = new Map<string, string>();
  for (const candidate of candidatesInOrder) {
    const normalized = String(candidate || '').trim();
    if (!normalized) continue;
    const key = normalizeLabelKey(normalized);
    if (!key || labelsByKey.has(key)) continue;
    labelsByKey.set(key, normalized);
  }
  return Array.from(labelsByKey.values()).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
  );
}
